export default __webpack_public_path__ + "static/media/basic-django-roadmap.a2c418e0.png";